import { isPlatformBrowser } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, Inject, Input, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatExpansionPanel } from '@angular/material/expansion';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { UserBrief } from 'src/app/core/models/user-brief.model';
import { LoggedInUserService } from 'src/app/core/services/logged-in-user.service';
import { TuwaiqUtil } from 'src/app/core/TuwaiqUtil';
import { REQUEST_TYPE } from 'src/app/shared/components/attachments/upload-attachments/upload-attachments.component';
import { PeriodicReviewConstants } from '../../constants/periodic-review-menu.constants';
import { DialogDataService } from '../../services/dialogDataService.service';
import { PeriodicModuleService } from '../../services/report-module.service';

@Component({
    selector: 'app-report-comments',
    templateUrl: './comments.component.html',
    styleUrls: ['./comments.component.scss']
})
export class CommentsReportsComponent implements OnInit {
    @Input() commentsAttachment;
    @Input() reportId;
    @Input() textHeader;
    @Input() commentType;
    @Input() viewOnly;
    @Input() pdfMode: boolean = false;
    @ViewChild('panel') panel: MatExpansionPanel;
    data: any;
    downloadAttachment: string = 'downloadAttachment';
    commentForm: FormGroup;
    inputFormControl = 'inputFormControl';
    isDisableAttachment;
    uploadAttachmentRequestType = REQUEST_TYPE.CREATE_REPORT;
    showAddComment: boolean = false;
    showListComments: boolean;
    showMoreDiv: boolean = false;
    maxLength = PeriodicReviewConstants.REPORT_FIELDS_MAX_LENGTH.createReport;
    isSubmitted: boolean;
    isDialog: boolean = false;
    filteredCommentsAttachment: any;
    isAttachmentListValid: boolean;
    attachmentList = [];
    userAttachment: string;
    activeIndex: number;
    isAdding: boolean;
    isReportDevice: boolean;
    isLoader: boolean = true;
    viewType: any;
    textComment: any;
    userDetails: UserBrief;
    @ViewChild('addSection') addSection!: ElementRef<HTMLInputElement>;
    disableBtn: boolean;
    isRemoveAttachment: boolean;
    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
        private cookies: CookieService,
        public translateService: TranslateService,
        public periodicModuleService: PeriodicModuleService,
        public formBuilder: FormBuilder,
        private loggedInUserService: LoggedInUserService,
        private toastr: ToastrService,
        private route: ActivatedRoute,
        private router: Router,
        public dialog: MatDialog,
        private dialogDataService: DialogDataService
    ) //@Inject(MAT_DIALOG_DATA) //public dialogData: { dataDialog: any },
    {
        this.initForm();
    }

    private initForm() {
        this.commentForm = this.formBuilder.group({
            inputFormControl: ['', Validators.required]
        });
    }

    ngOnInit(): void {
        this.isLoader = true;
        this.userDetails = this.loggedInUserService.getLoggedInUserDetails();
        this.data = this.dialogDataService.getData();
        if (this.data) {
            this.textHeader = this.data.data.textHeder;
            this.isDialog = this.data.data.dialog;
            this.commentType = this.data.data.commentType;
            this.isAdding = this.data.data.isAdding;
            this.reportId = this.data.data.reportId;
            this.viewType = this.data.data.viewType;
            this.isReportDevice = this.data.data.isReportDevice;
            if (this.isDialog == true) this.getCommentsAuditor();
        }

        this.handleUserAttachment();
        if (this.commentsAttachment) {
            this.filteredCommentsAttachment = this.commentsAttachment;
            if (this.filteredCommentsAttachment?.length > 0) {
                this.showListComments = true;
            } else {
                this.showListComments = false;
            }
            this.isLoader = false;
        }
    }

    getCommentsAuditor() {
        this.periodicModuleService?.getCommentsUsers(this.reportId)?.subscribe((response: any) => {
            if (response) {
                this.filteredCommentsAttachment = response.data;
                //if(this.loggedInUserService.getLoggedUserId()!== report?.creator?.id)
                //this.isAdding
                if (this.filteredCommentsAttachment.length > 0) {
                    this.showListComments = true;
                } else {
                    this.showListComments = false;
                }
                this.isLoader = false;
            }
        });
    }

    hasRequiredError(controlName: string) {
        return this.isSubmitted && this.commentForm.get(controlName).hasError('required');
    }

    send() {
        this.isSubmitted = true;
        this.disableBtn = true;

        if (this.commentForm.invalid) {
            this.disableBtn = false;
            return;
        }

        const commentType = this.commentType === 'commentTypeStakeholder' ? 'STAKEHOLDER' : 'CREATOR';
        const serviceMethod =
            commentType === 'STAKEHOLDER' ? this.periodicModuleService.addCommentReportStakeholderAudit : this.periodicModuleService.addCommentReportAudit;

        serviceMethod.call(this.periodicModuleService, this.prepareAndGetDataToSave(commentType)).subscribe({
            next: response => {
                this.handleSuccess(TuwaiqUtil.convertObjectKeysToCamelCase(response.data));
            },
            complete: () => {
                this.handleCompletion();
                this.disableBtn = false;
            },
            error: (error: HttpErrorResponse) => {
                this.handleError(error);
                this.disableBtn = false;
            }
        });
    }
    prepareAndGetDataToSave(action: string) {
        let apiData;
        this.textComment = this.commentForm.value.inputFormControl;
        if (this.attachmentList.length > 0) {
            apiData = {
                ['report-id']: this.reportId,
                body: this.commentForm.value.inputFormControl,
                attachments: this.handleCommentObject(action)
            };
        } else {
            apiData = {
                ['report-id']: this.reportId,
                body: this.commentForm.value.inputFormControl
            };
        }
        return apiData;
    }

    private handleSuccess(response): void {
        let message;
        message = this.translateService.instant('reportCommentCreationSuccessful');
        this.toastr.success(message);
        this.showListComments = true;
        //this.showAddComment = false;
        this.textComment = '';
        this.isRemoveAttachment = true;
        const currentDate = new Date();
        const responseAdded = {
            attachments: response.attachments,
            id: response.id,
            body: response.body,
            createdAt: currentDate,
            creatorBy: response.creatorBy,
            creator: {
                id: this.userDetails?.id,
                name: this.userDetails?.name,
                nameAr: this.userDetails?.nameAr,
                nameEn: this.userDetails?.nameEn,
                email: this.userDetails?.email,
                image: this.userDetails?.image
            }
        };
        this.filteredCommentsAttachment?.push(responseAdded);
    }

    private handleError(error: HttpErrorResponse): void {
        const errorMessage = error?.message || this.translateService.instant('reportCommentCreationFailed');
        this.toastr.error(errorMessage);
        this.isSubmitted = false;
        this.disableBtn = false;
    }

    private handleCompletion(): void {
        this.isSubmitted = false;
        this.disableBtn = false;
    }

    panelOpenState(state) {
        this.panel.expanded = state;
    }

    getCurrentLang(): any {
        if (isPlatformBrowser(this.platformId)) {
            return this.cookies.get('lang');
        }
    }

    storeAttachmentList(attachmentObj) {
        this.isAttachmentListValid = attachmentObj.isAttachmentListValid;
        this.attachmentList = attachmentObj.attachmentList;
    }

    handleCommentObject(action) {
        return this.periodicModuleService.handleAttachmentObject(this.attachmentList, action);
    }

    showComment() {
        this.panel.expanded = true;
        this.showAddComment = true;
        const element = this.addSection?.nativeElement;
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        element.focus(); // Focus on the section after scrolling
    }

    showMore(index: number) {
        this.activeIndex = this.activeIndex === index ? null : index; // Toggle active index
        this.showMoreDiv = !this.showMoreDiv;
    }

    cancelAdding() {
        this.showAddComment = false;
        this.dialog.closeAll();
        this.textComment = '';
        this.isRemoveAttachment = true;
    }

    onSearch(event: any): void {
        const searchTerm = event.target.value.toLowerCase();
        this.filteredCommentsAttachment = this.commentsAttachment.filter(option => {
            const searchMatches =
                option?.creator?.nameAr?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
                option?.creator?.nameEn?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
                option?.creator?.name?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
                option?.creator?.email?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
                option?.body?.toLowerCase().includes(searchTerm?.toLowerCase());

            return searchMatches;
        });

      
        if (searchTerm == '') {
            this.filteredCommentsAttachment = this.commentsAttachment;
            this.showListComments = true;
        }
        if (this.filteredCommentsAttachment.length == 0) {
            this.showListComments = false;
        }
    }

    handleUserAttachment() {
        if (this.commentType == 'commentTypeStakeholder') {
            this.userAttachment = 'STAKEHOLDER';
        } else {
            this.userAttachment = 'CREATOR';
        }
    }
}
